import React from "react";
import { Tab, TabList } from "react-tabs";

import WPHeading from "../WPHeading";

import { combineClassNames } from "../../utils/appUtils";

import "./WPTabs.scss";

export const WPVerticalTabItem = ({
  text,
  onClick,
  isActive,
  children,
  id,
}) => (
  <Tab
    id={id}
    className={combineClassNames("wp-vertical-tab-item", isActive && "active")}
    onClick={onClick}
    data-test-id={`tab-${id}`}
  >
    {text ?? children}
  </Tab>
);

//NOTE: Prefer passing tabs over children , the children support is added for not breaking existing implementations
export const WPVerticalTabsList = ({
  tabs,
  onTabClick,
  activeTab,
  children,
  identifier,
}) => (
  <div className="wp-vertical-tabs-list-wrapper">
    <TabList>
      {tabs?.map((tab) => {
        const tabKey = tab[identifier ?? "id"];
        const isActive = tabKey === activeTab;
        return (
          <WPVerticalTabItem
            key={tabKey}
            onClick={() => onTabClick(tabKey)}
            isActive={isActive}
            id={tabKey}
          >
            <WPHeading
              text={tab.name}
              secondary
              wrapContent={true}
              tooltip={tab.name}
              className="wp-vertical-tab-heading"
              color={
                isActive
                  ? "var(--du-color-primary-aquamarine)"
                  : "var(--du-color-black)"
              }
              fontNoto
            />
          </WPVerticalTabItem>
        );
      })}
      {children}
    </TabList>
  </div>
);
